// extracted by mini-css-extract-plugin
export default {"productGrid":"gZ-z","centerLink":"hZ-z","productSection":"iZ-z","item":"jZ-z","ctaButton":"kZ-z"};